import { Sticker } from './../types/index'
import axios from 'axios'
import {
  deleteStickerPathname,
  getEveryStickerCategoryPathname,
  postStickerPathname,
  putStickerCategory,
  replaceStickerPathname,
} from './pathname'

export const getStickerCategoryAPI = async () => {
  return axios.get(getEveryStickerCategoryPathname, {
    headers: {
      'Cache-Control': 'max-age=100000000',
    },
  })
}

export const tagUpdateAPI = async ({
  stickerOid,
  emojiCategories,
  sessionToken,
  textLang,
}: {
  stickerOid: string
  emojiCategories: number[] | null
  sessionToken: string
  textLang: string | null
}) => {
  const { data } = await axios.put(
    putStickerCategory(stickerOid),
    {
      emojiCategories,
      textLang,
    },
    {
      headers: {
        session: sessionToken,
      },
    },
  )
  return data
}
//session token 도 formdata 안에 있음
//삭제는 bff 에 구현 나머지는 기존의 스티커팜 서버에 구현
export const uploadStickerAPI = async (formData: FormData) => {
  const { data } = await axios.post(postStickerPathname, formData)
  return data
}
export const replaceStickerAPI = async (formData: FormData) => {
  const { data } = await axios.post(replaceStickerPathname, formData)
  return data
}

export const deleteStickerAPI = async ({
  stickerOid,
  sessionToken,
}: {
  stickerOid: string
  sessionToken: string
}) => {
  const { data } = await axios.delete(deleteStickerPathname(stickerOid), {
    headers: { session: sessionToken },
  })
  return data
}
